import AppTopbar from "../Components/AppTopbar";
import { useTranslation } from "react-i18next";
import dbservice from "../Utility/DbConnection/dbservice.js";
import { TransformIntSQLDate } from "../Utility/Utility";

import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";

import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import SearchPanelComponent from "../Components/Panels/SearchPanelComponent";
import { Image } from "primereact/image";
import dbManagerInterface from "../Utility/DbConnection/DBManagerInterface.js";
import { Panel } from "primereact/panel";

const route = "Automata/Alarms/";

function AlarmsPage() {
  const type = "alarms";
  const toast = useRef(null);
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [topNumber, setTopNumber] = useState(null);
  const [idValue, setIdValue] = useState(null);
  const [alarmData, setAlarmData] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [measuresMetadata, setMeasuresMetadata] = useState([]);
  const [onlyActive, setOnlyActive] = useState(false);

  const [loading, setLoading] = useState(false);
  const [isDataPresent, setIsDataPresent] = useState(false);

  useEffect(() => {}, []); // Dependency array is empty, so it runs only on mount
  useEffect(() => {
    setLoading(true);
    if (selectedMachine && measuresMetadata.length > 0) {
      setLoading(false);
      const actualDate = new Date();
      setEndDate(actualDate);
      const actualDateMinusOneDay = new Date(
        actualDate.getTime() - 24 * 60 * 60 * 1000
      );
      setStartDate(actualDateMinusOneDay);
    }
  }, [selectedMachine, measuresMetadata]);

  const onSearchClick = () => {
    const startDateSQL = TransformIntSQLDate(startDate);
    const endDateSQL = TransformIntSQLDate(endDate);

    setLoading(true);
    setIsDataPresent(false);

    if (startDate > endDate) {
      console.log("Start Date is greater than End Date");
      toast.current.show({
        severity: "error",
        summary: t("error"),
        detail: t("error1"),
        life: 3000,
      });
    }
    const machinesToSend = selectedMachine.map((machine) => machine.Machine);
    const body = {
      Machines: machinesToSend,
      DateStart: startDateSQL,
      DateEnd: endDateSQL,
      Top: topNumber,
      Id: idValue,
      OnlyActive: onlyActive,
    };
    const client = sessionStorage.getItem("chosenClient");
    const plant = sessionStorage.getItem("chosenPlant");
    const machine = "null";
    const queryParams = `Client=${client}-${plant}&Machine=${machine}`;

    dbManagerInterface.SendPostRequest(
      route + "GetAlarms",
      JSON.stringify(body),
      (resData) => {
        if (!resData.success || resData.data?.length === 0) {
          toast.current.show({
            severity: "warn",
            summary: t("warning"),
            detail: t("warning1"),
            life: 3000,
          });
          setIsDataPresent(false);
          setLoading(false);
        } else {
          setAlarmData(resData.data);
          //attach to res.Data the Description from measuresMetadata based on ID and Machine
          resData.data.forEach((alarm) => {
            const measure = measuresMetadata.find(
              (measure) =>
                measure.ID === alarm.ID && measure.Machine === alarm.Machine
            );
            if (measure) {
              alarm.Description = measure.Description;
            }
          });
          setIsDataPresent(true);
          setLoading(false);
        }
      },
      (error) => {
        console.error("error", error);
        setLoading(false);
        setIsDataPresent(false);
      },
      toast,
      "Get Alarms",
      queryParams
    );
  };

  const alarmStatusTemplate = (rowData) => {
    const status = rowData.STS;

    const getSeverity = (status) => {
      switch (status) {
        case 1:
          return "danger";
        case 0:
          return "success";
        default:
          return "info";
      }
    };
    // Return a Tag component with the appropriate severity based on the status
    const getStatusLabel = (status) => {
      switch (status) {
        case 1:
          return t("on");
        case 0:
          return t("off");
        default:
          return t("unknownStatus");
      }
    };

    return (
      <Tag value={getStatusLabel(status)} severity={getSeverity(status)} />
    );
  };

  return (
    <div>
      <AppTopbar title={t("alarms")} menuCode={1} />
      <Toast ref={toast} />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SearchPanelComponent
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          topNumber={topNumber}
          setTopNumber={setTopNumber}
          type={type}
          selectedMachine={selectedMachine}
          setMeasuresMetadata={setMeasuresMetadata}
          measuresMetadata={measuresMetadata}
          idValue={idValue}
          setIdValue={setIdValue}
          setSelectedMachine={setSelectedMachine}
          onSearchClick={onSearchClick}
          tableData={alarmData}
          onlyActive={onlyActive}
          setOnlyActive={setOnlyActive}
        />
        <Panel>
          <div
            style={{
              display: isDataPresent ? "block" : "none",
              width: "100%",
              overflowX: "auto",
            }}
          >
            <DataTable
              value={alarmData}
              stripedRows
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 20, 50]}
            >
              <Column field="TS" header={t("timestamp")} sortable></Column>
              <Column
                field="Machine"
                header={t("machine")}
                sortable
                filter
              ></Column>
              <Column
                field="Description"
                header={t("description")}
                sortable
                filter
              ></Column>
              <Column field="ID" header={t("id")} sortable filter></Column>
              <Column
                field="STS"
                header={t("status")}
                sortable
                filter
                body={alarmStatusTemplate}
              ></Column>
            </DataTable>
          </div>

          <div
            style={{
              display: loading ? "block" : "none",
            }}
          >
            <Image
              src={"/pms/loading.gif"}
              alt={"loading"}
              style={{ display: loading ? "block" : "none" }}
            ></Image>
          </div>

          <div
            style={{
              display: !isDataPresent && !loading ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              margin: "1%",
              textAlign: "center",
            }}
          >
            <h1 style={{ marginBottom: "1rem" }}>{t("noData")}</h1>
            <Image
              src={"/pms/no_data.gif"}
              alt={"no_data"}
              style={{ maxWidth: "300px", height: "450px", width: "100%" }}
            />
          </div>
        </Panel>
      </div>
    </div>
  );
}

export default AlarmsPage;
